import ActionTypes from './actionTypes';

export function getCardOptionsAction(accountNumber, grandParentAccountNumber) {
  return {
    type: ActionTypes.STORE.GET_CARD_OPTIONS.REQUEST,
    payload: {
      accountNumber,
      grandParentAccountNumber,
    },
  };
}

export function getCardOptionsReset() {
  return {
    type: ActionTypes.STORE.GET_CARD_OPTIONS.RESET,
  };
}

export function getVehicleTypesAction() {
  return {
    type: ActionTypes.STORE.GET_VEHICLE_TYPES.REQUEST,
  };
}

export function createCardOptionsAction(createCardOptionsRequest, grandParentAccountNumber) {
  return {
    type: ActionTypes.STORE.CREATE_CARD_OPTIONS.REQUEST,
    payload: {
      body: createCardOptionsRequest,
      grandParentAccountNumber: grandParentAccountNumber,
    },
  };
}

export function updateCardOptionsAction(updateCardOptionsRequest, grandParentAccountNumber) {
  return {
    type: ActionTypes.STORE.UPDATE_CARD_OPTIONS.REQUEST,
    payload: {
      body: updateCardOptionsRequest,
      grandParentAccountNumber: grandParentAccountNumber,
    },
  };
}

/**
 * Get list of report types
 * */
export function getReportTypes() {
  return {
    type: ActionTypes.STORE.GET_REPORT_TYPES.REQUEST
  };
}

export function getReportTypesSuccess(response) {
  return {
    type: ActionTypes.STORE.GET_REPORT_TYPES.SUCCESS,
    payload: {
      reportTypes: response
    }
  };
}

export function getReportTypesFailure() {
  return {
    type: ActionTypes.STORE.GET_REPORT_TYPES.FAILURE
  };
}
